<template>
  <div>
    <Select ref="select" v-model="localValue" :datas="datas" :keyName="keyName" :deletable="false"
            :titleName="titleName" :disabled="disabled" :equalWidth="false"
            filterable @input="selected"/>
    <div class="h-select-filterable-value show-value" :style="{color: disabled ? '#c1c1c1' : color, display}">{{ showValue }}</div>
  </div>
</template>
<script>

export default {
  props: {
    value: [String, Number],
    datas: {
      type: Array,
      required: true
    },
    keyName: {
      type: String,
      default: 'key'
    },
    titleName: {
      type: String,
      default: 'title'
    },
    // 展示选择后展示的字段
    showName: {
      type: String,
      default: 'title'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localValue: null,
      showValue: null,
      color: null,
      display: 'block',
      searchInput: null
    }
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
      if (this.datas.length) {
        const selectItem = this.datas.find(item => {
          const key = item[this.keyName].toString();
          const value = newVal.toString();
          return key === value;
        })
        this.searchInput.placeholder = '';
        this.showValue = selectItem[this.showName];
      }
    },
    datas: {
      immediate: true, // 确保首次渲染时也被触发
      handler(newDatas) {
        if (newDatas.length && this.value) {
          const selectedItem = newDatas.find(item => {
            const key = item[this.keyName].toString();
            const value = this.value.toString();
            return key === value;
          });
          this.showValue = selectedItem[this.showName];
          this.$nextTick(() => {
            this.searchInput.placeholder = '';
          })
        }
      }
    }
  },
  mounted() {
    this.searchInput = this.$refs.select.$el.querySelector('.h-select-search-input')
    this.searchInput.addEventListener('focus', this.forceListener)
    this.searchInput.addEventListener('blur', this.blurListener)
    this.searchInput.addEventListener('input', this.inputListener)
  },
  methods: {
    selected(val) {
      const selectedItem = this.datas.find(item => item[this.keyName] === val);
      this.$emit('input', val);
      this.$emit('change', selectedItem);
    },
    forceListener() {
      this.color = '#c1c1c1'
    },
    blurListener() {
      this.color = null;
      this.display = 'block';
    },
    inputListener() {
      if (this.searchInput.value !== '') {
        this.display = 'none'
      } else {
        this.display = 'block';
      }
    },
  },
  beforeDestroy() {
    this.searchInput.removeEventListener('focus', this.forceListener)
    this.searchInput.removeEventListener('blur', this.blurListener)
    this.searchInput.removeEventListener('input', this.inputListener)
  }
}
</script>

<style scoped lang="less">
/deep/ .h-select-filterable-value:not(.show-value) {
  display: none;
}

.show-value {
  top: 4px
}

</style>
